export const ACCOUNT_PLATFORM_OPTIONS = [
  { value: 'mt4', label: 'MT4' },
  { value: 'mt4_2', label: 'MT4_2' },
  { value: 'mt5', label: 'MT5' },
  { value: 'ctrader', label: 'CTRADER' },
];
